'use client';

import { useEffect } from 'react';
import { useRouter, useSearchParams } from 'next/navigation';

const STORAGE_KEY = 'saten_filters';
const FILTER_KEYS = ['q', 'size', 'material', 'length', 'color', 'brand', 'sort', 'availability', 'price_min', 'price_max', 'page'];

export default function FilterPersister() {
  const router = useRouter();
  const searchParams = useSearchParams();

  useEffect(() => {
    const hasParams = FILTER_KEYS.some(k => searchParams.get(k));

    if (hasParams) {
      // Save current filters
      const saved: Record<string, string> = {};
      FILTER_KEYS.forEach(k => {
        const v = searchParams.get(k);
        if (v) saved[k] = v;
      });
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(saved));
    } else {
      // No params in URL — restore if we have saved filters
      const raw = sessionStorage.getItem(STORAGE_KEY);
      if (raw) {
        try {
          const saved = JSON.parse(raw) as Record<string, string>;
          const params = new URLSearchParams(saved);
          router.replace('/?' + params.toString());
        } catch {
          sessionStorage.removeItem(STORAGE_KEY);
        }
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
}
